import store from '@/store'

export default (to, from, next) => {
    const { user } = store.getters

    if (user.accepted_terms) {
        next()
    } else {
        next('/onboarding/terms-of-service')
    }
}
